

import Trailer from "../components/Trailer";
import Footer from "../components/Footer/Footer";

const Home = () => {
  return (
    <div>
    
      <Trailer />
      <Footer />
    </div>
  );
};

export default Home;
